import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DbwContainerComponent} from './dbw-container/dbw-container.component';
import {DbwTitleContainerComponent} from './dbw-title-container/dbw-title-container.component';
import {DbwTitleComponent} from './dbw-title/dbw-title.component';
import {DbwTitleToolsComponent} from './dbw-title-tools/dbw-title-tools.component';
import {DbwWidgetBodyComponent} from './dbw-widget-body/dbw-widget-body.component';
import {DbwWidgetToolbarComponent} from './dbw-widget-toolbar/dbw-widget-toolbar.component';
import {DbwEditFilterBtnComponent} from './dbw-edit-filter-btn/dbw-edit-filter-btn.component';
import {
  DbwWidgetToolbarToggleBtnComponent
} from './dbw-widget-toolbar-toggle-btn/dbw-widget-toolbar-toggle-btn.component';
import {DbwWidgetViewComponent} from './dbw-widget-view/dbw-widget-view.component';
import {DbwViewButtonsComponent} from '@feature/_app_modules/dbw-layout/dbw-view-buttons/dbw-view-buttons.component';
import {DbwWidgetViewBodyComponent} from './dbw-widget-view-body/dbw-widget-view-body.component';
import {DbwWidgetViewFooterComponent} from './dbw-widget-view-footer/dbw-widget-view-footer.component';
import {DbwPrintBtnComponent} from "@feature/_app_modules/dbw-layout/dbw-print-btn/dbw-print-btn.component";
import {PrintingModule} from "@feature/_app_modules/printing/printing.module";
import {TooltipModule} from "primeng/tooltip";


@NgModule({
  declarations: [
    DbwContainerComponent,
    DbwTitleContainerComponent,
    DbwTitleComponent,
    DbwTitleToolsComponent,
    DbwWidgetBodyComponent,
    DbwWidgetToolbarComponent,
    DbwEditFilterBtnComponent,
    DbwWidgetToolbarToggleBtnComponent,
    DbwViewButtonsComponent,
    DbwWidgetViewComponent,
    DbwWidgetViewBodyComponent,
    DbwWidgetViewFooterComponent,
    DbwPrintBtnComponent

  ],
    imports: [
        CommonModule,
        PrintingModule,
        TooltipModule
    ],
  exports: [
    DbwContainerComponent,
    DbwTitleContainerComponent,
    DbwTitleComponent,
    DbwTitleToolsComponent,
    DbwWidgetBodyComponent,
    DbwWidgetToolbarComponent,
    DbwEditFilterBtnComponent,
    DbwWidgetToolbarToggleBtnComponent,
    DbwViewButtonsComponent,
    DbwWidgetViewComponent,
    DbwWidgetViewBodyComponent,
    DbwWidgetViewFooterComponent,
    DbwPrintBtnComponent
  ]
})
export class DbwLayoutModule {
}
